import { call, select, put, takeEvery } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import getHtmlString from "../../components/PageNewsletterTemplate/functions/getHtmlString";
import getDoctype from "../../components/PageNewsletterTemplate/functions/getDoctype";
import NewsletterHtmlContainer from '../../components/PageNewsletterTemplate/cont/NewsletterHtmlContainer'
import getNewsletterRawData from "../../components/PageNewsletterTemplate/functions/getNewsletterRawData";
import { newsletterCampaignCreate, newsletterCampaignSend } from "../../apis/wpApi/apiCalls";
import getData from "../../functions/getData";
import { FEATURES } from '../../constants/state'
import authUser from "../../apis/wpApi/authUser";


export function* onSuccess(successType) {
    yield put({
        type: successType
    })
}

export function* onError(errorType, errorMessage) {
    yield put({
        type: errorType,  
        payload: {
            errorMessage: errorMessage
        }
    })
}

export const getSendNewsletter = state => ({
    sendNewsletter: getData(state, [FEATURES, 'has_newsletter_send'])
})


function* createNewsletter(apiKey, cinema_pk, newsletter_pk, data) {
    const htmlNewsletter = yield getHtmlString(NewsletterHtmlContainer, data)
    const htmlContent = yield getDoctype() + htmlNewsletter
    const subject  = yield data.campaign.get('name')

    if(!subject) {
        throw new Error('No newsletter subject')
    }

    if(!htmlContent) {
        throw new Error('No newsletter content')
    }

    return yield call(newsletterCampaignCreate, apiKey, {
        cinemaPk: cinema_pk,
        newsletterPk: newsletter_pk,
        htmlContent: htmlContent,
        subject: subject,
    })
}

function* sendSingleNewsletter(apiKey, campaignId) {
    const data = yield select(getNewsletterRawData(campaignId))
    const cinema_pk = yield data.campaign.get('cinema')
    const newsletter_pk = yield data.campaign.get('pk')
    const responseCreate = yield call(createNewsletter,apiKey, cinema_pk, newsletter_pk, data)

    let response

    if(responseCreate && 200 === responseCreate.status && responseCreate.data && 'string' === typeof responseCreate.data) {
        const { sendNewsletter } = yield select(getSendNewsletter)

        if(!sendNewsletter) {
            response = responseCreate
        } else {
            response = yield call(newsletterCampaignSend, apiKey, {
                cinemaPk:  cinema_pk,
                campaignPk: responseCreate.data
            })

            if(!response || response.status != 200) {
                throw new Error('Could not send newsletter')
            }
        }
    } else {
        throw new Error('Could not create campaign')
    }

    return yield response
}

function* sendNewsletter({payload}){
    try {
        const { campaignId } = yield payload
        const apiKey = yield call(authUser.getToken)

        if('all' === campaignId) {
            throw new Error('campaign all disabled')
        }

        yield call(sendSingleNewsletter, apiKey, campaignId)
        yield call(onSuccess, actionTypes.NEWSLETTER_SEND_SUCCESS)
    } catch(e){
        console.log('Newsletter send error', e)
        yield call(onError, actionTypes.NEWSLETTER_SEND_ERROR, e.message)
    }
}


function* watchNewsletterSendRequest() {
    try {
        yield takeEvery(actionTypes.NEWSLETTER_SEND_REQUEST, sendNewsletter)
    } catch(e) {
        console.log('error', e.message)
    }
}


export default watchNewsletterSendRequest;